export default "__VITE_ASSET__HgCVM3QU__"